import React from "react";
import Layout from "../../components/layout";
import { Link } from "react-router-dom";

import styles from "./NotFoundPage.module.scss";
import { route } from "../../static/route";

const NotFoundPage = () => {
  const companyName = process.env.REACT_APP_COMPANY_NAME;

  return (
    <Layout>
      <div className={styles.NotFoundPage}>
        <div className="w-full px-10 h-[200px] mt-[10px] text-center flex flex-col justify-center">
          <h1 className="text-5xl font-bold text-white">{companyName}</h1>

          <hr className="w-[180px] border-white border-[4px] rounded-[4px] mx-auto mt-4" />
        </div>
        <div className="mt-[70px] px-10 py-5 text-center">
          <p className="mt-4 text-primary-2 font-bold text-2xl">
            Page Not Found (404)
          </p>
          <p className="mt-4 text-primary-2 font-semibold text-lg">
            Sorry, the page you are looking for is not available on our website.
            The URL you entered may be incorrect or the page has been removed.
          </p>
          <p className="mt-4 text-primary-2 font-semibold text-lg">
            Go to home page: To visit our website's home page <br />
            <Link to={route.home}>
              <a className="text-xl font-bold underline">click here.</a>
            </Link>
          </p>
        </div>
      </div>
    </Layout>
  );
};
export default NotFoundPage;
